module.exports = __webpack_public_path__ + "static/media/wal.f045afc5.svg";